module.exports = __webpack_public_path__ + "img/9788962604467.9612b6d1.jpg";